import { lazy } from 'react';
import { authRoles } from 'src/app/auth';

const SeviceDeskApp = lazy(() => import('./ServiceDeskApp'));

const ServiceDeskAppConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.admin,
  routes: [
    {
      path: '/apps/service-desk',
      element: <SeviceDeskApp />,
    },
  ],
};

export default ServiceDeskAppConfig;
